import React, {useEffect, useState} from 'react'
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import FlipNumbers from "react-flip-numbers";

const Results=()=>{
    const [timetaken,setTimetaken]= useState("00:00:00")
    const [level1,setLevel1]= useState(0)
    const [level2,setLevel2]= useState(0)
    const [level3,setLevel3]= useState(0)

    function toHoursAndMinutes(totalSeconds) {
        const totalMinutes = Math.floor(totalSeconds / 60);

        const seconds = totalSeconds % 60;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        return <span>{hours}:{minutes}:{seconds}</span>;
    }

    useEffect(() => {
        setLevel1(localStorage.getItem('level1'))
        setLevel2(localStorage.getItem('level2'))
        setLevel3(localStorage.getItem('level3'))

        var tt = parseInt(localStorage.getItem('timetakenl1'))+parseInt(localStorage.getItem('timetakenl2'))+parseInt(localStorage.getItem('timetakenl3'));
        tt = 135-(tt);
        tt = toHoursAndMinutes(tt)
        setTimetaken(tt)

    },[]);

    return (
        <>
            <section className="sec-gamification">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 p-0">
                            <div className="gamification-dv">

                                <div className="srceen srceen7">
                                    <div className="lavel-last">
                                        <div className="text-center congratulationhd"><span><img
                                            src="assets/images/congratulation-img/bh1.png" className="img-fluid" alt=""/></span>
                                            <h2>Congratulations </h2></div>
                                        <div className="yourscrnbd">
                                            <div className="bgcnb1">
                                                <div className="yourscrn1">Your Score</div>
                                                <div className="score-nums1"><span><img
                                                    src="assets/images/star-score-icon.svg" className="img-fluid"
                                                    alt=""/><img src="assets/images/star-score-icon.svg"
                                                                className="img-fluid" alt=""/><img
                                                    src="assets/images/star-score-icon.svg" className="img-fluid"
                                                    alt=""/></span>

                                                    <FlipNumbers
                                                        play
                                                        color="#000"
                                                        background=""
                                                        width={50}
                                                        height={50}
                                                        perspective={500}
                                                        duration={3}
                                                        delay={1}
                                                        numbers={((5/100)*( (level1*(100/2)) + (level2*(100/4)) + (level3*(100/6)) )/3).toFixed(1)}
                                                    />

                                                </div>
                                                <div className="outoffv">Out of 5</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="texthd">
                                        <div className="text-center totacloctime">
                                            <span><img src="assets/images/congratulation-img/clock-img.svg"
                                                       className="img-fluid" alt=""/></span>
                                            <div className="time">{timetaken}</div>
                                            <div className="tottime">Total taken time</div>
                                        </div>
                                        <div className="lavescn1bg">
                                            <div className="lavescn1">
                                                <div className="lavescnNum">Lavel 1</div>
                                                <div className="progress pron1">
                                                    <div className="progress-bar bg-succes" role="progressbar"
                                                         style={{width: `${level1*(100/2)}%`}} aria-valuenow="100" aria-valuemin="0"
                                                         aria-valuemax="100"></div>
                                                </div>
                                                <div className="lavescnCnt"><span>{level1}</span>/2</div>
                                            </div>
                                            <div className="lavescn1">
                                                <div className="lavescnNum">Lavel 2</div>
                                                <div className="progress pron2">
                                                    <div className="progress-bar bg-orang" role="progressbar"
                                                         style={{width: `${level2*(100/4)}%`}} aria-valuenow="25" aria-valuemin="0"
                                                         aria-valuemax="100"></div>
                                                </div>
                                                <div className="lavescnCnt"><span>{level2}</span>/4</div>
                                            </div>
                                            <div className="lavescn1">
                                                <div className="lavescnNum">Lavel 3</div>
                                                <div className="progress pron3">
                                                    <div className="progress-bar bg-blu" role="progressbar"
                                                         style={{width: `${level3*(100/6)}%`}} aria-valuenow="25" aria-valuemin="0"
                                                         aria-valuemax="100"></div>
                                                </div>
                                                <div className="lavescnCnt"><span>{level3}</span>/6</div>
                                            </div>
                                        </div>
                                        <div className="texthdTx">
                                            <div className="text-center"><Link to="/" className="get-started btnv6">Play
                                                Again </Link></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


export default Results;